import React, { Component } from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import './custom.css';
import './styles.css';

import Footer from './footer';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import ModalDialog from '@atlaskit/modal-dialog';

import { sendData } from '../websocket';
// import { displayConsole } from '../helper';
import { displayConsole, getPublicIp } from '../helper';
import { connect } from '../../base/redux';
import { translate } from '../../base/i18n';
import { Translate } from "../language";

import {
  setData,
  setUserConnectionStatus,
  setVideoScreenStatus,
  setJoinRoomModalStatus,
  getipListFromApi,
  clickAutoMakeHost,
  setHybridSession,
  setDelayPanning,
  showToastPopup,
  setRoomorIpAddress,
  showApiLoader,
  hideApiLoader
} from '../../customise/redux/tool-webjam/actions';
import type { Dispatch } from 'redux';

import refresh from './img/refresh.png';
import cross from './img/cross.png';

const publicIP = require('public-ip');
import Toast from 'react-simple-toasts';
import Tutorial from './tutorial';
import {
  FEATURE_CUSTOM_PAYMENT,
  FEATURE_CUSTOM_REDUX,
  FEATURE_CUSTOM_REDUX_V2,
  FEATURE_CUSTOM_REDUX_V3
} from "../../customise/constant"
import { dispatch, getBaseConfig, isSocialMobileApp, PANNING_VAR, _ValidateIPaddress, getStore } from '../../customise/Utils';
import { sendAnalytics } from '../../analytics';
import { Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME } from '../constant';
import { setDeviceContainerStatus, setEnableWebjamModal } from '../../customise/redux/tool-webjam-v2/actions';
import { addDeviceBox, getDevicePingStatus, getIpValidation, updateUserJamStateReq } from '../../customise/welcome-dashboard/Request.d';
import { setLocalAutoConnect, setLocalBufferValue, setIsMixerMuteByDefault, showTutorialModal, setShowDevicePreConnection, setUserStaticDeviceId, setManualBoxProcess, setConfirmationModalProps } from '../../customise/redux/tool-webjam-v3/actions';
import { makeHostRoomStatus, userHasSubscription } from '../../customise/custom/components/HelperComponent';
import UserSubscription from '../../customise/custom/components/UserSubscription';
import { SaveLog } from '../../customise/Utils';
import toast from 'react-simple-toasts';
import { GenericConfirmationModal } from '../../customise/custom/components/GenericConfirmationModal';
import { getLJsonStorage } from '../../customise/welcome-dashboard/Utils';
import Dialog from '../../base/ui/components/web/Dialog';
import { checkSubscription, ct } from '../../customise/constant-Utils';
import { handleSubscription } from '../../customise/custom/components/CommonComponents';

let timeoutHelpScreen, this_;

type Props = {

  dispatch: Dispatch<any>
};

class DeviceList extends Component<Props, *> {

  // state = {
  //   waitMsg: true,
  //   isOpen: false,
  //   deviceId: '',
  //   showHelpModal: false,
  //   isAskAgain: false,
  //   // current: 0
  // }

  constructor() {
    super();
    this.slideRef = React.createRef();
    this.back = this.back.bind(this);
    this.next = this.next.bind(this);
    this.state = {
      waitMsg: true,
      current: 0,
      isOpen: false,
      deviceId: '',
      showHelpModal: false,
      isAskAgain: localStorage.getItem("askAgain") ? true : false,
      isAutoConnect: localStorage.getItem("autoConnect") ? true : false,
      showSubscription: false,
      showLoginConfirm: false,
      showPrejoinModal: false,
      userConnectedPrejoin: false,
      selectedDeviceId: ''
    };
  }

  componentDidMount() {
    //REMOVE MAKEE HOST variable: true
    localStorage.removeItem('makeHostConnect');
    localStorage.removeItem('thirdPartyMakeHostConnect');
    //: GET & SAVE IPLIST (ONLY TRMC) 
    //this.props.dispatch(getipListFromApi());

    this_ = this;

    setTimeout(() => {
      this_.setState({ waitMsg: false });
    }, 15000);

    // if(this.props.clickMakeHost != true) {
    (async () => {
      // displayConsole('publicIP', await publicIP.default.v4());
      // let publicIp = await publicIP.default.v4();
      let publicIp = await getPublicIp();

      var message = {
        action: {
          publicIp: publicIp,
          userId: this.props?.userLoginData?.user?.id || null
        },
        content: 'device-list',
        isBroadcast: true,
        sender: 'mobile'
      }

      //-------------Prepare logger data -------------
      var log_data = {
        functionName: '',
        triggeredBy: 'system',
        event: message.content,
        requestData: message,
        responseData: '',
        userId: '',
        boxId: '',
        message: 'Emit to server'
      }
      SaveLog(log_data);
      //-------------------------------------------

      sendData(message)
    })();
    // }

    let noChangedRoomName = getBaseConfig('noChangedRoomName')
    if (noChangedRoomName == true) {
      this.setState({
        isAutoConnect: this.props.localAutoConnect
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, isHelpModal, videoScreenStatus, joinRoomModalStatus, usersData, apiGetIpList } = this.props;

    if (prevProps.joinRoomModalStatus !== joinRoomModalStatus && usersData === undefined) {
      dispatch(setJoinRoomModalStatus({
        joinRoomModalStatus: false
      }));
      this.props.changePopupState('');
    }

    if (prevProps.videoScreenStatus !== videoScreenStatus) {
      if (videoScreenStatus) {
        dispatch(setVideoScreenStatus({
          videoScreenStatus: false
        }));
        this.props.changePopupState('');
      }
    }

    if (prevProps.isHelpModal !== isHelpModal) {
      if (isHelpModal) {
        if (timeoutHelpScreen) {
          clearTimeout(timeoutHelpScreen);
        }
        this._showHelpModal(false);
        dispatch(setUserConnectionStatus({
          isConnected: false,
          isHelpModal: false
        }));
      }
    }

    try {
      const { userPaymentSubscription } = this.props;

      if (prevProps.userPaymentSubscription != userPaymentSubscription) {
        // console.log("=> new subscription ", userPaymentSubscription)
        if (userPaymentSubscription.name) {
          if (userPaymentSubscription.is_premium) {
            this.setState({
              showSubscription: false
            })
          }
        }
      }
    } catch (e) {
      console.log("=> err webjam", e)
    }
  }

  closeDeviceModal() {
    dispatch(setDeviceContainerStatus("closeDeviceList", 'DeviceList'))
    dispatch(setEnableWebjamModal(false))
    dispatch(setUserStaticDeviceId(""))
    this.props.changePopupState('');
  }

  _closeHelpModal() {
    this_.setState({ showHelpModal: false });
  }

  back() {
    this.slideRef.current.goBack();
  }

  next() {
    this.slideRef.current.goNext();
  }

  renderHelpModal() {

    const properties = {
      // duration: 5000,
      autoplay: false,
      // transitionDuration: 500,
      arrows: false,
      // infinite: true,
      // easing: "ease",
      indicators: true
    };

    const slides = [
      {
        key: 'one',
        title: ct("rta-trmc.webjam.slides.titleOne"),
        text: ct("rta-trmc.webjam.slides.textOne")
      },
      {
        key: 'two',
        title: ct("rta-trmc.webjam.slides.titleTwo"),
        text: ct("rta-trmc.webjam.slides.textTwo")
      },
      {
        key: 'three',
        title: ct("rta-trmc.webjam.slides.titleThree"),
        text: ct("rta-trmc.webjam.slides.textThree")
      },
      {
        key: 'three',
        title: ct("rta-trmc.webjam.slides.textFour"),
        text: ct("rta-trmc.webjam.slides.titleFive")
      },
      {
        key: 'three',
        title: ct("rta-trmc.webjam.slides.titleFive"),
        text: ct("rta-trmc.webjam.slides.textFive")
      },
      {
        key: 'three',
        title: ct("rta-trmc.webjam.slides.titleSix"),
        text: ct("rta-trmc.webjam.slides.textSix")
      }
    ];

    return (
      <ModalTransition className="help-slider-wrapper">
        <Modal onClose={this._closeHelpModal}
          testId={"webjam-tab"}

        >
          <div className="newDIv">
            <span className="close" onClick={this._closeHelpModal}>
              <img src={cross} />
            </span>
            <div className="App slider-webtec">
              <div className="slide-container">
                <Slide ref={this.slideRef} {...properties}>
                  {slides.map((each, index) => (
                    <div key={index} className="each-slide">
                      <div className="titleHelpModal">{each.title}</div>
                      <div className="contentHelpModal">{each.text}</div>
                    </div>
                  ))}
                </Slide>
              </div>

              <div className="slide-container buttons buttonWrapper">
                <button className="skipleft" onClick={this._closeHelpModal} type="button">
                  {ct("rta-trmc.rtaDeviceListDialog.skipBtn")}
                </button>
                <button className="nextright" onClick={this.next} type="button">
                  {ct("Translate.buttonTitle.next")}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </ModalTransition>)
  }

  handleChange = (event) => {
    const { name, value, } = event.target;
    if (value?.length <= 6) {
      this_.setState({
        deviceId: value.toUpperCase(),
      });
    } else {
      toast(ct("rta-trmc.rtaDeviceListDialog.enterManuallyValidateLength"))
    }
  };

  askAgain = () => {
    const { isAskAgain } = this.state;
    if (isAskAgain) {
      localStorage.removeItem("askAgain");
      this.setState({
        isAskAgain: false
      })
    } else {
      this.setState({
        isAskAgain: true
      })
      localStorage.setItem("askAgain", 'true');
    }
  };

  autoConnect = () => {
    const { isAutoConnect } = this.state;
    if (isAutoConnect) {
      //localStorage.removeItem("autoConnect");
      this.setState({
        isAutoConnect: false
      })
    } else {
      this.setState({
        isAutoConnect: true
      })
      localStorage.setItem("autoConnect", 'true');
      let noChangedRoomName = getBaseConfig('noChangedRoomName')
      if (noChangedRoomName == true) {
        dispatch(setLocalAutoConnect(true));
      }
    }
  };

  enterDevice = async (event) => {
    localStorage.removeItem('makeHostConnect');
    localStorage.removeItem('thirdPartyMakeHostConnect');
    const { protocolId, dispatch, connected, roomorIpAddress, apiGetIpList } = this_.props;

    if (_ValidateIPaddress(roomorIpAddress)) {
      let isValid = await getIpValidation(roomorIpAddress);
      if (isValid.status == 0) {
        setTimeout(function () {
          Toast(ct("messages.enterDiffIpAddress", "messages"), 15000);
        }, 1000);
        return false;
      }
    }

    // if (apiGetIpList && roomorIpAddress.includes('.')) {
    //   let ipArr = apiGetIpList.data;
    //   if (!ipArr.includes(roomorIpAddress)) {
    //     setTimeout(function () {
    //       Toast('The IP address you have entered is invalid. Please choose a different room name or IP address.', 3000);
    //     }, 1000);
    //     return false;
    //   }
    // }
    const { name, value, } = event.target;
    const deviceId = value.toUpperCase();
    let noChangedRoomName = getBaseConfig('noChangedRoomName')
    let roomorIpAddressNew = roomorIpAddress
    if (noChangedRoomName == true) {
      if (roomorIpAddressNew && roomorIpAddressNew.indexOf("_") != -1) {
        roomorIpAddressNew = roomorIpAddressNew.replace("_", ":")
      }
    }
    //SET DEVICE ID IN STORAGE
    sessionStorage.setItem("foundDeviceId", deviceId);
    localStorage.setItem("uniqueID", deviceId);
    sessionStorage.setItem("foundProtocolId", protocolId);

    const obj = {
      uniqueId: deviceId,
      room: roomorIpAddressNew,
      connected
    }
    dispatch(setData(obj));

    const message = {
      action: {
        uniqueID: deviceId,
        ipAddress: roomorIpAddressNew,
        protocolId,
      },
      content: 'unique_check',
      isBroadcast: true,
      sender: 'mobile',
      scope: 'enterDevice'
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: '',
      triggeredBy: 'system',
      event: message.content,
      requestData: message,
      responseData: '',
      userId: '',
      boxId: message.action.uniqueID || ' available',
      message: 'Emit to server'
    }
    SaveLog(log_data);
    //-------------------------------------------

    displayConsole('Send unique_check', message);
    sendData(message);
    timeoutHelpScreen = setTimeout(() => {
      this_._showHelpModal();
    }, 12000);
    dispatch(setEnableWebjamModal(false));
  }

  _showHelpModal() {
    const { joinRoomModalStatus } = this.props;
    if (joinRoomModalStatus) {
      this.setState({
        showHelpModal: true,
      });
      // } else {
      // it was giving mixer fade issue for the first time
      //   this.props.changePopupState('');
    }
  }

  troubleHelp = () => {
    dispatch(showTutorialModal(true));
    this.closeDeviceModal();
    this.setState({
      showHelpModal: true,
    });
  }

  checkSoftware = () => {
    var appInstalled = false;
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.onload = function () {
      appInstalled = true;
    };
    iframe.onerror = function () {
      appInstalled = false;
    };
    iframe.src = 'realtimeaudio://';
    document.body.appendChild(iframe);
    setTimeout(function () {
      document.body.removeChild(iframe);
      if (appInstalled) {
        console.log('checkSoftware installed =>');
      } else {
        console.log('checkSoftware not installed =>');
      }
    }, 5000);
  }

  softwareDetail = () => {
    this.checkSoftware()
    dispatch(setConfirmationModalProps({
      isShow: true,
      title: ct("rta-trmc.softwareVersion.softwareVersionTitle"),
      content: <>{ct("rta-trmc.softwareVersion.softwareVersionContent")} <span onClick={() => {
        window.location.href = "https://taylorrobinsonmusic.s3.amazonaws.com/realtimeaudio.zip";
        dispatch(setConfirmationModalProps({ isShow: false }));
      }} className="hyperlink-text">{ct("rta-trmc.softwareVersion.softwareVersionLink")}</span></>,
      showOkButton: false,
      cancelBtnName: ct("rta-trmc.softwareVersion.softwareVersionCancelBtn"),
      onCancel: () => {
        dispatch(setConfirmationModalProps({ isShow: false }));
      }
    }));
  }

  enterDeviceManually = async (device_id) => {
    const { userLoginData, userPaymentSubscription } = this.props
    let willConnect = true;
    let getUserSubs = userHasSubscription(true, "webjam")
    const userSubscription = getStore(FEATURE_CUSTOM_PAYMENT)?.userPaymentSubscription;
    if (!checkSubscription() || !userSubscription?.is_premium) {
      console.log("subs 2 =>")
      if (getBaseConfig("showPreJoiningInConference")) {
        dispatch(setUserStaticDeviceId(device_id))
      }
      handleSubscription("box");
      return false;
    }

    let deviceID = device_id;
    deviceID = deviceID.replace(/[^a-zA-Z0-9]/g, '')

    if (deviceID) {
      console.log("userLoginData ", userLoginData)
      if (userLoginData?.user?.id) {
        if (userLoginData.user.is_invited == true) {
          if (userLoginData?.user?.rtaSocialUserId == undefined) {
            this.setState({
              showLoginConfirm: true
            })
            return false;
          }
        }

        if (getUserSubs) {
          if (!userPaymentSubscription.is_premium) {
            this.setState({
              showSubscription: true
            })
            dispatch(setManualBoxProcess({
              isRunning: true,
              processData: {
                device_id: deviceID,
                user_id: userLoginData.user.id
              }
            }))
            willConnect = false;
          }
        }
      } else {
        this.setState({
          showLoginConfirm: true
        })
        return false;
      }

      if (willConnect) {
        let isAdded = await addDeviceBox({
          device_id: deviceID,
          user_id: userLoginData.user.id
        })

        if (isAdded.status == 1) {
          localStorage.setItem("uniqueID", deviceID);
          dispatch(setData({
            uniqueId: deviceID,
          }));
          this.closeDeviceModal();
          this_.setState({
            deviceId: "",
          });
          setTimeout(() => {
            dispatch(setShowDevicePreConnection(true))
          }, 1000)
        }
      }
    } else {
      toast(ct("rta-trmc.rtaDeviceListDialog.enterManuallyValidateEmpty"))
    }
  }

  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this._startWebjam();
    }
  }

  async _startWebjam(item) {
    const userSubscription = getStore(FEATURE_CUSTOM_PAYMENT)?.userPaymentSubscription;
    console.log('check subscription on box click ===>', userSubscription)
    // CUSTOM
    const { dispatch, protocolId } = this.props;
    console.log("subs 1 =>", checkSubscription(), userSubscription?.is_premium)
    if (!checkSubscription() || !userSubscription?.is_premium) {
      console.log("subs 2 =>")
      if (getBaseConfig("showPreJoiningInConference")) {
        dispatch(setUserStaticDeviceId(item))
      }
      handleSubscription("box");
      return false;
    }
    // END

    let getUserSubs = userHasSubscription(true, "webjam")

    let isSubscriptionReq = getBaseConfig("subscriptionRequired");
    let willJoin = true;
    let isUserLogin = true;

    const {
      userLoginData,
      userPaymentSubscription
    } = this.props;

    if (userLoginData.user.id && userLoginData.user.is_invited == true) {
      console.log("userLoginData ", userLoginData)
      if (userLoginData?.user?.rtaSocialUserId == undefined) {
        this.setState({
          showLoginConfirm: true
        })
        return false;
      }
    }


    dispatch(setHybridSession(false, "_startWebjam"))

    if (isSubscriptionReq == true) {
      willJoin = false
      if (getUserSubs) {
        willJoin = true;
        if (userLoginData?.user?.id) {
          if (!userPaymentSubscription.is_premium) {
            willJoin = false;
            if (getBaseConfig("showPreJoiningInConference")) {
              dispatch(setUserStaticDeviceId(item))
            }
          }
        }
      } else {
        if (!userLoginData?.user?.id) {
          willJoin = false;
          isUserLogin = false;
        }
      }
    }

    if (!willJoin) {
      if (!isUserLogin) {
        console.log("user is not loginIn")
      }
    }

    if (!willJoin) {
      if (!isUserLogin) {
        if (getBaseConfig("prejoinLoginRequired") == true) {
          this.setState({
            showLoginConfirm: true
          })
        } else {
          toast(ct("Translate.messages.needLoginToConnect"))
        }

      } else {
        this.setState({
          showSubscription: true
        })
      }
      return false;
    }

    if (getBaseConfig("recheckConnectDevice") == true) {
      let hasPrejoinConnected = sessionStorage.getItem("dv_cnf_tm");
      let canUserConnect = false;
      let userHasPrejoin = false

      try {
        let connectedDetails = JSON.parse(hasPrejoinConnected);
        if (connectedDetails.hasOwnProperty("id")) {
          userHasPrejoin = true;
          if (connectedDetails.id == item && !getBaseConfig("showPreJoiningInConference")) {
            canUserConnect = true;
          }
        } else {
          userHasPrejoin = false;
        }
      } catch (e) {
        userHasPrejoin = false;
      }

      if (!canUserConnect) {
        console.log("Setting heree")
        if (getBaseConfig("showPreJoiningInConference")) {
          dispatch(setShowDevicePreConnection(true));
          dispatch(setUserStaticDeviceId(item))
        } else {
          this.setState({
            userConnectedPrejoin: userHasPrejoin,
            showPrejoinModal: !canUserConnect,
            selectedDeviceId: item
          })
        }
        return false;
      }

      dispatch(showApiLoader())

      let pingStatus = await getDevicePingStatus({
        device_id: item,
        protocol_id: protocolId,
        room_name: CURRENT_ROOM_NAME
      });

      dispatch(hideApiLoader())
      if (pingStatus.status == 0) {
        console.log("Setting heree B")
        this.setState({
          userConnectedPrejoin: userHasPrejoin,
          showPrejoinModal: true,
          selectedDeviceId: item,
          moveToPrejoin: true
        })
        return false;
      }
    }

    //: 
    localStorage.removeItem('makeHostConnect');
    localStorage.removeItem('thirdPartyMakeHostConnect');
    const { connected, roomorIpAddress, apiGetIpList } = this_.props;

    if (_ValidateIPaddress(roomorIpAddress)) {
      let isValid = await getIpValidation(roomorIpAddress);
      if (isValid.status == 0) {
        setTimeout(function () {
          Toast(ct("messages.enterDiffIpAddress", "messages"), 15000);
        }, 1000);
        return false;
      }
    }

    let noChangedRoomName = getBaseConfig('noChangedRoomName')
    let roomorIpAddressNew = roomorIpAddress
    if (noChangedRoomName == true) {
      roomorIpAddressNew = await makeHostRoomStatus()
    }

    console.log("device connected room ", roomorIpAddressNew)

    // SET ROOM NAME IN LOCAL STORAGE
    localStorage.setItem("roomFound", roomorIpAddressNew);
    localStorage.removeItem('newRoomHosted');
    localStorage.removeItem('autoConnect');
    if (noChangedRoomName == true) {
      dispatch(setLocalAutoConnect(false));
    }
    // localStorage.removeItem('bufferValue');
    dispatch(setLocalBufferValue(false))
    localStorage.removeItem('autopopup');

    // hide previous hybrid and auto manage host checkbox state/ set them false
    // dispatch(clickAutoMakeHost(false))
    dispatch(setHybridSession(false, "_startWebjam"))

    //SET DEVICE ID IN STORAGE
    sessionStorage.setItem("foundDeviceId", item);
    localStorage.setItem("uniqueID", item);
    sessionStorage.setItem("foundProtocolId", protocolId);

    const obj = {
      uniqueId: item,
      room: roomorIpAddressNew,
      connected
    }

    dispatch(setData(obj));
    dispatch(setDelayPanning(PANNING_VAR.NO_PANNING));

    const message = {
      action: {
        uniqueID: item,
        ipAddress: roomorIpAddressNew,
        protocolId,
      },
      content: 'unique_check',
      isBroadcast: true,
      sender: 'mobile',
      scope: '_startWebjam'
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: '',
      triggeredBy: 'system',
      event: message.content,
      requestData: message,
      responseData: '',
      userId: '',
      boxId: message.action.uniqueID || ' available',
      message: 'Emit to server'
    }
    SaveLog(log_data);
    //-------------------------------------------

    displayConsole('Send unique_check', message);
    // sendData(message);
    sendData(message, {
      loaderAdditionalDetail: ct("Translate.messages.deviceConnecting"),
      type: 1
    });

    timeoutHelpScreen = setTimeout(() => {
      this_._showHelpModal();
    }, 12000);

    sendAnalytics({
      action: 'device-connect',
      source: "toolbar",
      category: "device connect"
    });
    dispatch(setEnableWebjamModal(false));
    dispatch(setIsMixerMuteByDefault(true))
  }

  handleCloseSubscription = () => {
    console.log("close subscription ")
    this.setState({
      showSubscription: false
    })
  }

  handleRedirectToSocial = async (e) => {

    if (getBaseConfig("showPreJoiningInConference")) {
      dispatch(setShowDevicePreConnection(true));
      this.setState({
        showPrejoinModal: false
      })
      dispatch(setUserStaticDeviceId(this.state.selectedDeviceId))
    } else {
      const param = CURRENT_ROOM_LOCATION + '?device_id=' + this.state.selectedDeviceId;
      window.history.pushState({ path: param }, '', param);
      if (getLJsonStorage("auth", "is_invited")) {
        try {
          let auth = JSON.parse(localStorage.getItem("auth"));
          delete auth.is_invited;
          let newAuth = { ...auth };
          newAuth = JSON.stringify(newAuth)
          localStorage.setItem("auth", newAuth)
          localStorage.removeItem('socialAuthToken')
        } catch (e) {
        }
      }
      // await updateUserJamStateReq({
      //   jamming_capability: 2,
      //   room_name: CURRENT_ROOM_NAME
      // })
      sessionStorage.removeItem("dv_cnf_tm");
      sessionStorage.removeItem("up_time_" + CURRENT_ROOM_NAME);
      setTimeout(function () {
        window.location.reload();
      }, 100)
    }
  }

  handlePrejoinCancel = () => {
    this.setState({ showPrejoinModal: false });
  }

  render() {
    const { deviceId, showHelpModal, isAskAgain, isAutoConnect } = this.state;
    const {
      usersData,
      deviceList,
      changePopupState,
      prejoinScreenDetail,
      showDevicePreConnection,
      prejoinAvailableDevice,
      enableWebjamModal,
      conferenceJoined,
    } = this.props;

    var deviceListTitle = getBaseConfig("deviceListTitle");

    if (usersData != null) {
      return null;
    }

    // if prejoin's screen has device connected then don't show devices popup
    if (prejoinScreenDetail.isSet) {
      return null;
    }

    if (showDevicePreConnection) {
      return null;
    }

    let allDevices = deviceList
    if (getBaseConfig("showPreJoiningInConference")) {
      allDevices = deviceList ? deviceList : []
      if (prejoinAvailableDevice && prejoinAvailableDevice.length) {
        allDevices = allDevices.concat(prejoinAvailableDevice)
      }
      allDevices = [...new Set(allDevices)];
    }

    return (
      <>
        {this.state.showSubscription ? <UserSubscription
          closeSubscription={this.handleCloseSubscription}
        /> : null}

        {this.state.showLoginConfirm &&
          <GenericConfirmationModal

            title={ct("rta-trmc.signInSignUpPage.signIn")}
            successBtnName={ct("Translate.buttonTitle.okSmall")}
            cancelBtnName={ct("Translate.buttonTitle.cancelSmall")}
            content={ct("Translate.confirmMessages.confirmSocialRedirect")}
            onSuccess={async () => {
              localStorage.removeItem("auth");
              sessionStorage.removeItem("dv_cnf_tm");
              sessionStorage.removeItem("up_time_" + CURRENT_ROOM_NAME);
              localStorage.removeItem('socialAuthToken');

              if (isSocialMobileApp()) {
                window.parent.location.href = getBaseConfig("appReferrerUrl");
              } else {
                // social url change code
                let socialAllowed = getBaseConfig("socialAllowed");
                if (socialAllowed == true) {
                  if (window.parent != undefined) {
                    window.parent.location.href = Constant.App.socialUrl + "?prejoin_roomname=" + CURRENT_ROOM_NAME;
                  } else {
                    window.location.href = Constant.App.socialUrl + "?prejoin_roomname=" + CURRENT_ROOM_NAME
                  }
                } else {
                  window.location.href = Constant.App.socialUrl + "?prejoin_roomname=" + CURRENT_ROOM_NAME
                }
              }
            }}
            onCancel={() => this.setState({ showLoginConfirm: false })} />
        }

        {this.state.showPrejoinModal &&
          <GenericConfirmationModal
            title={ct("Translate.typography.rtaDevice")}
            successBtnName={ct("Translate.buttonTitle.okCaps")}
            cancelBtnName={ct("Translate.buttonTitle.cancelSmall")}
            content={this.state.userConnectedPrejoin ? ct("Translate.confirmMessages.userConnectedDevice") : ct("Translate.confirmMessages.userNotConnectedDevice")}
            onSuccess={(e) => {
              this.handleRedirectToSocial(e)
            }}
            onCancel={() => {
              this.handlePrejoinCancel()
            }} />
        }

        {(this.props.explorePop === "webjam" || (enableWebjamModal && conferenceJoined)) &&
          <Dialog
            disableAutoHideOnSubmit={true}
            disableBackdropClose={true}
            hideCloseButton={false}
            onCancel={() => this.closeDeviceModal()}
            cancel={{ hidden: true }}
            ok={{ hidden: true }}
            size={'large'}
            rtaClassName={'conference-deivice-list'}
            title={<span className="refresh img"><img height={50} className="refresh" src={refresh} onClick={() => {
              (async () => {
                // displayConsole('publicIP', await publicIP.default.v4());
                // let publicIp = await publicIP.default.v4();
                let publicIp = await getPublicIp();

                //-------------Prepare logger data -------------
                var log_data = {
                  functionName: 'Refresh List',
                  triggeredBy: 'user',
                  event: 'device-list',
                  requestData: {
                    action: {
                      publicIp: publicIp,
                    },
                    content: 'device-list',
                    isBroadcast: true,
                    sender: 'mobile'
                  },
                  responseData: '',
                  userId: '',
                  boxId: '',
                  message: 'Emit to server'
                }
                SaveLog(log_data);
                //-------------------------------------------

                sendData({
                  action: {
                    publicIp: publicIp,
                    userId: this.props?.userLoginData?.user?.id || null
                  },
                  content: 'device-list',
                  isBroadcast: true,
                  sender: 'mobile'
                })
              })();
            }} /></span>}
            testId="webjam-modal"
          >
            {/* END */}
            {/* <ModalDialog
          testId="webjam-modal"
          dialogClassName="modal-dialog webjam out-wrapper-ui"
          width="x-large"> */}

            {/* {!usersData ? */}
            <div className="parent-dvc">
              {
                allDevices && allDevices.length > 0 ?
                  (
                    <div className="container-fluid">
                      {/* advance-setting */}
                      <div className="setting-advance-main top-space">
                        <div className="pik-div">
                          {/* <label className="pik-dvc"> Pick a Device ID </label> */}
                          {/* <label className="pik-dvc"> We detected a RealTime Audio Box. <br /> Please select your device ID. </label> */}
                          <label className="pik-dvc px-4" dangerouslySetInnerHTML={{ __html: deviceListTitle }}></label>
                        </div>

                        {/* <div className="id-wrapper"> */}
                        <span id="rta-devices-list" className="id-wrapper d-block px-4">
                          {
                            allDevices && allDevices.length > 0 ?
                              allDevices.map((item, idx) => {
                                return (
                                  <div key={idx}>
                                    <div className="box-btn-wrap">
                                      <input style={{ cursor: 'pointer' }} key={idx} type="text" value={item} onClick={() => this_._startWebjam(item)} className="form-control" readOnly />
                                      <button onClick={() => this_._startWebjam(item)}>{ct("rta-trmc.rtaDeviceListDialog.connect")}</button>
                                    </div>
                                  </div>
                                );
                              }) :
                              (
                                <div>
                                  <input type="text" value="No Devices Found" className="form-control" readOnly />
                                </div>
                              )
                          }

                          {/* </div> */}
                        </span>
                        <div className="pik-div">
                          {/* <label className="pik-dvc"> or Enter Device ID </label> */}
                        </div>
                        <div className="advanced-detail">
                          <span className="skip-head d-block px-4">
                            <p>{ct("rta-trmc.rtaDeviceListDialog.skipText")}</p>
                            <button id='skip-btn' onClick={() => this.closeDeviceModal()}>{ct("rta-trmc.rtaDeviceListDialog.skipBtn")}</button>
                            <div className="new ask-head dont-ask-check">
                              <label className="container"><p>{ct("rta-trmc.rtaDeviceListDialog.doNotShow")}</p>
                                <input type="checkbox" value={isAskAgain}
                                  checked={isAskAgain} onChange={this.askAgain} />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                            {/* </div> */}
                          </span>
                        </div>
                        {/* {showHelpModal && this.renderHelpModal()} */}
                        {/* {showHelpModal && <Tutorial onClose={this._closeHelpModal} />} */}
                      </div>
                    </div>
                  ) :
                  (
                    <div className="container-fluid">
                      {/* no-device */}
                      <div className="no-device-main">

                        {this.state.waitMsg ?
                          <div className="pik-div">
                            {/* <label className="pik-dvc not-detect">Checking for the RealTime Audio Box...</label> */}
                            <label className="pik-dvc not-detect">{getBaseConfig("deviceListSearch")}</label>
                          </div>
                          :
                          <>
                            <div className="">
                              {/* <label className="pik-dvc not-detect">
                          We did not detect a RealTime Audio Box. Without one, you will not be able to experience ultra-low latency.
                        </label> */}
                              {/* <label className="pik-dvc not-detect"> */}
                              <label className="pik-dvc not-detect px-4">{getBaseConfig("deviceListSearchFailed")}</label>
                              {!getBaseConfig("showSoftwareVersion") &&
                                <button onClick={this.troubleHelp}>{ct("rta-trmc.rtaDeviceListDialog.troubleShootDetect")}</button>
                              }
                            </div>

                            {getBaseConfig("showPreJoiningInConference") &&
                              <>
                                {!getBaseConfig("showSoftwareVersion") &&
                                  <div className="pik-div">
                                    <label className="pik-dvc not-detect">{ct("rta-trmc.rtaDeviceListDialog.enterManuallyTitle")}</label>
                                  </div>
                                }
                                <div className="enter-dvc">
                                  <input id='enter-manual-device-input' type="text" name="deviceId" value={deviceId} placeholder={ct("rta-trmc.rtaDeviceListDialog.enterManuallyPlaceholder")} autoComplete='off' className="form-control"
                                    onChange={this.handleChange} onKeyDown={this._handleKeyDown} />
                                  <button id='enter-manual-device-btn' onClick={() => { this.enterDeviceManually(deviceId) }}>{ct("rta-trmc.rtaDeviceListDialog.connect")}</button>
                                </div>
                              </>
                            }
                            {getBaseConfig("showSoftwareVersion") &&
                              <div className='another-options'>
                                <label className='pik-dvc'>{ct("rta-trmc.rtaDeviceListDialog.softwareVersionText")}</label>
                                <div className='another-options-inner d-flex'>
                                  <div className='buy-device'>
                                    <button onClick={this.troubleHelp}>{ct("rta-trmc.rtaDeviceListDialog.troubleShootDetect")}</button>
                                  </div>
                                  <div className='user-software-version'>
                                    <button onClick={this.softwareDetail}>{ct("rta-trmc.rtaDeviceListDialog.useSoftwareVersion")}</button>
                                  </div>
                                </div>
                              </div>
                            }
                          </>
                        }


                        <div className="id-wrapper hide-devices"> </div>
                        {/* <div className="pik-div"> </div> */}

                        <div className="advanced-detail">
                          <div className="skip-head inner-click">
                            {/* <p>Don’t have a RealTime Audio Box? You can click “Skip” to enter without ultra-low latency audio.</p> */}
                            <p>{getBaseConfig("skipDeviceConnect")}</p>
                            <button onClick={() => this.closeDeviceModal()}>{ct("rta-trmc.rtaDeviceListDialog.skipBtn")}</button>
                            <div className="new ask-head dont-ask-check">
                              <label className="container"><p>{ct("rta-trmc.rtaDeviceListDialog.doNotShow")}</p>
                                <input type="checkbox" value={isAskAgain}
                                  checked={isAskAgain} onChange={this.askAgain} />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                            <div className="live-click">
                              {/* <p>or go <a href="https://realtimeaudio.com/hardware/" target="_blank" className="border-bottom-link">here</a> to purchase a RealTime Audio Box.</p> */}
                              <p>{ct("rta-trmc.rtaDeviceListDialog.orGo")} <a href="https://realtimeaudio.com/hardware/" target="_blank" className="border-bottom-link">{ct("rta-trmc.rtaDeviceListDialog.here")}</a>{getBaseConfig("purchaseBoxTitle")}</p>
                            </div>
                          </div>
                        </div>
                        {/* {showHelpModal && this.renderHelpModal()} */}
                        {/* {showHelpModal && <Tutorial onClose={this._closeHelpModal} />} */}
                      </div>
                    </div>
                  )
              }

            </div>

            {/* : null } */}

            {/* </ModalDialog > */}
          </Dialog>}
        {/* END */}
      </>

    )
    //: null }
  }
}

function _mapStateToProps(state) {
  return {
    usersData: state[FEATURE_CUSTOM_REDUX].usersData,
    protocolId: state[FEATURE_CUSTOM_REDUX].protocolId,
    uniqueId: state[FEATURE_CUSTOM_REDUX].uniqueId,
    room: state[FEATURE_CUSTOM_REDUX].room,
    deviceList: state[FEATURE_CUSTOM_REDUX].deviceList,
    connected: state[FEATURE_CUSTOM_REDUX].connected,
    isHelpModal: state[FEATURE_CUSTOM_REDUX].isHelpModal,
    textMessage: state['trmc/customLoader/modal'].textMessage,
    videoScreenStatus: state[FEATURE_CUSTOM_REDUX].videoScreenStatus,
    roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
    apiGetIpList: state[FEATURE_CUSTOM_REDUX].apiGetIpList,
    clickMakeHost: state[FEATURE_CUSTOM_REDUX].clickMakeHost,
    prejoinScreenDetail: state[FEATURE_CUSTOM_REDUX_V2].prejoinScreenDetail,
    localAutoConnect: state[FEATURE_CUSTOM_REDUX_V3].localAutoConnect,
    userPaymentSubscription: state[FEATURE_CUSTOM_PAYMENT].userPaymentSubscription,
    userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
    showDevicePreConnection: state[FEATURE_CUSTOM_REDUX_V3].showDevicePreConnection,
    prejoinAvailableDevice: state[FEATURE_CUSTOM_REDUX_V3].prejoinAvailableDevice,
    enableWebjamModal: state[FEATURE_CUSTOM_REDUX_V2].enableWebjamModal,
    conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
    manualBoxProcess: state[FEATURE_CUSTOM_REDUX_V3].manualBoxProcess,
  };
}

export default translate(connect(_mapStateToProps)(DeviceList));
